import React from 'react';
export const Initial = React.lazy(() => import('./Initial.jsx'));